import * as React from 'react'

import {
  Building2Icon,
  CalendarIcon,
  PackageIcon,
  UserRoundIcon,
  WrenchIcon,
} from 'lucide-react'

import { Battery55Icon } from '~/client/src/shared/components/icons/Battery55Icon'
import { HumidityMidIcon } from '~/client/src/shared/components/icons/HumidityMidIcon'
import { LocationLocationIcon } from '~/client/src/shared/components/icons/LocationLocationIcon'
import { SensorIcon } from '~/client/src/shared/components/icons/SensorIcon'
import { SignalIcon } from '~/client/src/shared/components/icons/SignalIcon'
import { TemperatureIcon } from '~/client/src/shared/components/icons/TemperatureIcon'

import { ResourceSemanticIconKey } from '../definitions'

const RESOURCE_ICON_CONFIG: Record<
  ResourceSemanticIconKey,
  React.ComponentType<{ className?: string }>
> = {
  // The Company glyph this design system already uses — see permittedCompanies and
  // PermitFieldType.Company. Deliberately lucide building-2, not the Building location type.
  company: Building2Icon,
  user: UserRoundIcon,
  date: CalendarIcon,
  sensor: SensorIcon,
  battery: Battery55Icon,
  temperature: TemperatureIcon,
  humidity: HumidityMidIcon,
  telemetry: SignalIcon,
  location: LocationLocationIcon,
  equipment: WrenchIcon,
  material: PackageIcon,
}

const ICON_BASE = 'tw:block tw:size-full'
const ICON_META = `${ICON_BASE} tw:text-muted-foreground`

const DEFAULT_ICON_CLASS: Record<ResourceSemanticIconKey, string> = {
  company: ICON_META,
  user: ICON_META,
  date: ICON_META,
  sensor: `${ICON_BASE} tw:text-muted-foreground`,
  battery: `${ICON_BASE} tw:text-success`,
  temperature: ICON_META,
  humidity: ICON_META,
  telemetry: ICON_META,
  location: ICON_META,
  equipment: `${ICON_BASE} tw:text-foreground`,
  material: `${ICON_BASE} tw:text-foreground`,
}

export const renderResourceSemanticIcon = (
  iconKey: ResourceSemanticIconKey,
  classNameOverride?: string,
): React.ReactNode => {
  const Component = RESOURCE_ICON_CONFIG[iconKey]
  if (!Component) return null
  return (
    <Component className={classNameOverride || DEFAULT_ICON_CLASS[iconKey]} />
  )
}
